import { tKeys, useTranslation } from 'locales';
import type { Sync } from 'shared/hooks/use-load-syncs';

export const useSyncTitle = () => {
  const { t } = useTranslation();

  return (sync: Sync) => (sync.kind === 'email' ? t(tKeys.NAV.SYNC.MAILBOX) : sync.integration);
};
